import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ContentContext = createContext({});

export function ContentProvider({ children }) {
    const [content, setContent] = useState({});

    useEffect(() => {
        api.get("/content")
            .then((r) => setContent(r.data || {}))
            .catch(() => setContent({}));
    }, []);

    const refresh = async () => {
        const r = await api.get("/content");
        setContent(r.data || {});
    };

    return (
        <ContentContext.Provider value={{ content, refresh }}>
            {children}
        </ContentContext.Provider>
    );
}

export function useContent() {
    return useContext(ContentContext);
}

export function useText(key, fallback = "") {
    const { content } = useContent();
    return content[key] ?? fallback;
}
